import { useMemo } from 'react';
import { defaultDateRange } from 'components/filter/input/DateRangePicker/presets';
import { defaultCreationDateRange } from 'components/filter/modules/article-visibility/defaults';
import { FormattedMessage } from 'react-intl';
import { useAppStore } from 'hooks/state/useAppStore';
import { useFilterSetsSessionStore } from 'hooks/state/usePersistedStore';
import { Button } from 'components/Button';

export function ClearFilterButton() {
  const defaultDateRanges = defaultDateRange();
  const defaultCreationDateRanges = defaultCreationDateRange();

  const {
    clearAll,
    dateRange,
    creationDateRange,
    brands,
    categories,
    colors,
    genders,
    ageGroups,
    seasons,
    countries,
    marketplaces,
    fulfillmentMethods,
    products,
    sizes,
    benchmark,
    dateBy,
    groupByAttribute,
  } = useAppStore();

  const { setSelectedFilterSet, setLastClickedFilterSet } = useFilterSetsSessionStore();

  const isNotDefaultDateRange = useMemo(
    () =>
      dateRange?.range.presetValue !== defaultDateRanges?.range.presetValue ||
      dateRange?.comparison?.presetValue !== defaultDateRanges?.comparison?.presetValue,
    [dateRange, defaultDateRanges]
  );

  const isNotDefaultCreationDateRange = useMemo(
    () => creationDateRange?.range?.presetValue !== defaultCreationDateRanges?.range?.presetValue,
    [creationDateRange, defaultCreationDateRanges]
  );

  const hasFilters = useMemo(
    () =>
      isNotDefaultDateRange ||
      isNotDefaultCreationDateRange ||
      (countries ?? []).length > 0 ||
      (categories ?? []).length > 0 ||
      (genders ?? []).length > 0 ||
      (ageGroups ?? []).length > 0 ||
      (seasons ?? []).length > 0 ||
      (brands ?? []).length > 0 ||
      (marketplaces ?? []).length > 0 ||
      (fulfillmentMethods ?? []).length > 0 ||
      (products ?? []).length > 0 ||
      (colors ?? []).length > 0 ||
      (sizes ?? []).length > 0 ||
      (benchmark ?? null) !== 'all' ||
      (dateBy ?? null) !== 'order' ||
      groupByAttribute != null,
    [
      isNotDefaultDateRange,
      isNotDefaultCreationDateRange,
      countries,
      categories,
      genders,
      ageGroups,
      seasons,
      brands,
      marketplaces,
      fulfillmentMethods,
      products,
      colors,
      sizes,
      benchmark,
      dateBy,
      groupByAttribute,
    ]
  );

  const clearFilters = () => {
    clearAll();
    setSelectedFilterSet(null);
    setLastClickedFilterSet(null);
  };

  return (
    <div>
      {hasFilters && (
        <Button id="clear-all-filters-button" priority="ghost" onClick={clearFilters} iconLeft="Cross" size="sm">
          <FormattedMessage id="general.button.clear.all" defaultMessage="Clear all" />
        </Button>
      )}
    </div>
  );
}
